import type { DeliveryInfo } from '~/types/resources/deliveryInfo';

export const equalDeliveryInfo = (
  deliveryInfo1: DeliveryInfo | null,
  deliveryInfo2: DeliveryInfo | null
) => {
  if (deliveryInfo1 == null || deliveryInfo2 == null) return false;
  if (deliveryInfo1.country != deliveryInfo2.country) return false;
  if (deliveryInfo1.address1 != deliveryInfo2.address1) return false;
  if (deliveryInfo1.address2 != deliveryInfo2.address2) return false;
  if (deliveryInfo1.city != deliveryInfo2.city) return false;
  if (deliveryInfo1.email != deliveryInfo2.email) return false;
  if (deliveryInfo1.fullname != deliveryInfo2.fullname) return false;
  if (deliveryInfo1.phone_number != deliveryInfo2.phone_number) return false;
  if (deliveryInfo1.prefecture != deliveryInfo2.prefecture) return false;
  if (deliveryInfo1.zip_code != deliveryInfo2.zip_code) return false;
  return true;
};
